import * as React from "react";
import classnames from "classnames";
import { UspGroupItem } from "@grandvisionhq/content";
import { Heading } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import { useCartStorage } from "@grandvisionhq/lib-utils-cart";
import { DeliveryIndicator } from "@grandvisionhq/shipping";
import { useFeatureToggles } from "@grandvisionhq/state";
import { isDefined } from "@grandvisionhq/utils";
import { extractSkuQuantityPairsFromLineItems } from "../../../../../../utils/utils/extract-sku-qauntity-pairs.js";
import { UnavailableLineItemsContainer } from "../../../../../LineItems/containers/modules/LineItems/containers/UnavailableLineItemsContainer.js";
import { VisualLineItemsContainer } from "../../../../../LineItems/VisualLineItemsContainer/modules/LineItems/VisualLineItemsContainer/VisualLineItemsContainer.js";
import { PrescriptionAlertMessage } from "../../../../../PrescriptionAlertMessage/modules/PrescriptionAlertMessage/PrescriptionAlertMessage.js";
/* empty css                                               */
import { useCartHeaderActionSlots } from "../../../../../../slots/header-slot/slots/header-slot/context.js";
import { useCartSidebarSlots } from "../../../../../../slots/sidebar-slot/slots/sidebar-slot/context.js";
import { useCartFooterSlots } from "../../../../../../slots/footer-slot/slots/footer-slot/context.js";
import { SummaryContainer } from "../../../../../Summary/modules/Summary/SummaryContainer.js";
const Cart = ({
  cartId,
  deliveryResolver,
  donation,
  hasSubscription,
  isReadOnly,
  labels,
  lineItems,
  policyItems,
  selectedPaymentMethodPrice,
  unavailableLineItems,
  visualLineItems,
  hasDistinctDeliveryEstimationsAlert = false
}) => {
  const { Slots: CartHeaderComponents } = useCartHeaderActionSlots();
  const { Slots: CartSidebarComponents } = useCartSidebarSlots();
  const { Slots: CartFooterComponents } = useCartFooterSlots();
  const [{ cartHash }] = useCartStorage();
  const { isCartDeliveryIndicatorEnabled } = useFeatureToggles();
  const availability = lineItems.map((item) => item.availability);
  const deliveryItems = extractSkuQuantityPairsFromLineItems(lineItems).filter(isDefined);
  return /* @__PURE__ */ React.createElement("section", { className: classnames("cart", { "cart--read-only": isReadOnly }), "data-t": "cart" }, /* @__PURE__ */ React.createElement(Heading, { variant: "medium", component: "h1", className: "cart__heading" }, labels.cartTitle), hasDistinctDeliveryEstimationsAlert ? /* @__PURE__ */ React.createElement(
    Alert,
    {
      className: "cart__alert",
      title: labels.alertDistinctDeliveryEstimationsTitle,
      variant: "info"
    },
    labels.alertDistinctDeliveryEstimationsDescription
  ) : null, CartHeaderComponents.FirstComponent ? /* @__PURE__ */ React.createElement(CartHeaderComponents.FirstComponent, { cartId }) : !!lineItems.length && isCartDeliveryIndicatorEnabled && /* @__PURE__ */ React.createElement(
    DeliveryIndicator,
    {
      items: deliveryItems,
      availability,
      deliveryResolver
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "cart__content" }, /* @__PURE__ */ React.createElement("div", { className: "cart__main" }, /* @__PURE__ */ React.createElement(VisualLineItemsContainer, { lineItems: visualLineItems, isReadOnly }), !isReadOnly && /* @__PURE__ */ React.createElement(PrescriptionAlertMessage, { lineItems: visualLineItems, className: "cart__rx-alert" }), /* @__PURE__ */ React.createElement(
    UnavailableLineItemsContainer,
    {
      unavailableLineItems,
      labels
    }
  ), policyItems && /* @__PURE__ */ React.createElement("div", { className: "usp-group__container" }, policyItems.map((item) => /* @__PURE__ */ React.createElement(UspGroupItem, { item, key: item.text }))), CartFooterComponents.CartOfferingsBanners && /* @__PURE__ */ React.createElement(
    CartFooterComponents.CartOfferingsBanners,
    {
      visualLineItems,
      lineItems,
      cartId
    }
  )), /* @__PURE__ */ React.createElement("aside", { className: "cart__sidebar" }, !isReadOnly && CartSidebarComponents.FirstComponent && /* @__PURE__ */ React.createElement(CartSidebarComponents.FirstComponent, { cartId, cartHash }), CartSidebarComponents.SecondComponent && /* @__PURE__ */ React.createElement(CartSidebarComponents.SecondComponent, { isReadOnly }), /* @__PURE__ */ React.createElement(
    SummaryContainer,
    {
      selectedPaymentMethodPrice,
      hasSubscription,
      isReadOnly,
      ...donation?.amount && { donationAmount: donation.amount }
    }
  ))));
};
export {
  Cart
};
//# sourceMappingURL=Cart.js.map
